import { StyleSheet } from 'react-native-unistyles'

import UniText from '@/components/unistyles/UniText'

const InfoText = ({ text }: { text?: string }) => {
  if (!text) return null

  return <UniText style={[styles.root]}>{text}</UniText>
}

const styles = StyleSheet.create((theme) => ({
  root: {
    marginBottom: theme.tokens.spacing[3],
    marginTop: theme.tokens.spacing[1],
    width: '100%',
  },
}))

export default InfoText
